import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { isMobile } from "react-device-detect";
import Alert from "@material-ui/lab/Alert";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormLabel from "@material-ui/core/FormLabel";
import ClassSharpIcon from "@material-ui/icons/ClassSharp";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import FormControl from "@material-ui/core/FormControl";
import FormGroup from "@material-ui/core/FormGroup";
import Snackbar from "@material-ui/core/Snackbar";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import TextField from "@material-ui/core/TextField";
import { LayoutQuiz } from "../../container/layout";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Countdown, { zeroPad } from "react-countdown";
// import useCountDown from "react-countdown-hook";
import Checkbox from "@material-ui/core/Checkbox";
import Button from "@material-ui/core/Button";
import DGAlert, { DGAlertQuiz } from "../../component/alert";
import { useNavigate, useParams } from "react-router-dom";
import clsx from "clsx";
import { loadQuiz, saveResult, updateCache } from "./action";
import { initPage } from "../home/action";
import moment from "moment";
import { inituser } from "../login/action";
import Timer from "./Timer";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: 32,
  },
  main: {
    textAlign: "center",
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  banner: {
    [theme.breakpoints.down("sm")]: {
      paddingTop: 58,
    },
    [theme.breakpoints.down("md")]: {
      padding: 16,
      boxSizing: "border-box",
    },
    [theme.breakpoints.up("md")]: {
      paddingTop: 113.51,
    },
    width: "100%",
    maxWidth: 953,
    maxHeight: 250,
    objectFit: "cover",
    margin: "0 auto",
    color: "#000000",
    textAlign: "center",
    "& img": {
      width: "100%",
      maxWidth: 953,
      maxHeight: 250,
      objectFit: "cover",
    },
  },
  titleSpace: {
    margin: 16,
  },
  textDesc: {
    color: "#585251",
    fontSize: 18,
    lineHeight: "32px",
    fontWeight: 400,
  },
  items: {
    fontFamily: "AP",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "18px",
    lineHeight: "32px",
    textAlign: "left",
  },
  buttonPrev: {
    marginTop: 32,
    maxWidth: "332px",
    width: "100%",
    height: "70px",
    padding: 0,
    fontSize: 24,
    fontWeight: 500,
    background: "#1B1E76",
    color: "#FFFFFF",
    [theme.breakpoints.down("md")]: {
      maxWidth: 146,
    },
  },
  buttonNext: {
    marginTop: 32,
    width: "100%",
    maxWidth: "332px",
    height: "70px",
    padding: 0,
    fontSize: 24,
    fontWeight: 500,
    marginLeft: 16,
    [theme.breakpoints.down("md")]: {
      maxWidth: 146,
    },
  },
  headerText: {
    fontWeight: 700,
    fontSize: 36,
    lineHeight: "56px",
    letterSpacing: "0.01em",
    margin: 0,
    padding: "32px 0 8px 0",
    borderBottom: "1px solid #EFEFEF",
    [theme.breakpoints.down("xs")]: {
      fontSize: 24,
      fontWeight: 500,
      lineHeight: "32px",
    },
  },
  formInput: {
    padding: 16,
    border: "1px solid #EFEFEF",
    [theme.breakpoints.up("md")]: {
      border: "none",
    },
  },
  formInputBox: {
    [theme.breakpoints.down("md")]: {
      padding: 16,
      boxSizing: "border-box",
    },
  },
  quizcontent: {
    textAlign: "left",
    maxWidth: 831,
    float: "left",
  },
  countdown: {
    fontSize: 44,
    fontWeight: 700,
    color: "#c92028",
  },
  countdownMobile: {
    fontSize: 20,
    fontWeight: 800,
    color: "#c92028",
  },
  date: {
    display: "flex",
    justifyContent: "space-between",
    lineHeight: "32px",
    fontSize: 24,
    margin: "16px 0 16px 0",
    fontWeight: 300,
    [theme.breakpoints.down("md")]: {
      fontSize: "16px !important",
      margin: 0,
    },
  },
  imageQuiz: {
    width: "100%",
    margin: "16px 0 16px 0",
    "& img": {
      maxWidth: "100%",
    },
  },
  partName: {
    backgroundColor: "#FFFFFF",
    fontSize: 24,
    marginLeft: -16,
    padding: 8,
    marginTop: 16,
    color: "#000000",
    fontWeight: 400,
    lineHeight: "32px",
    [theme.breakpoints.down("xs")]: {
      fontSize: 16,
      fontWeight: 400,
      lineHeight: "28px",
    },
  },
  topic: {
    marginBottom: 8,
    color: "#000000",
    lineHeight: "32px",
    fontSize: 18,
    fontWeight: 501,
    [theme.breakpoints.down("xs")]: {
      fontSize: 16,
      fontWeight: 501,
      lineHeight: "28px",
    },
  },
  labelradio: {
    flex: "49%",
    marginTop: 8,
    lineHeight: "32px",
    fontSize: 18,
    color: "#000000",
    [theme.breakpoints.down("xs")]: {
      fontSize: 16,
      fontWeight: 400,
      lineHeight: "32px",
    },
  },
  startText: {
    fontSize: 18,
    lineHeight: "32px",
    fontWeight: 500,
  },
}));

const Quiz = () => {
  const { id } = useParams();

  const [quiz, setQuiz] = React.useState({
    quiz: [],
    des: "",
    name: "",
    anspush: {},
    ansSelected: {},
    errorText: {},
    qgroupId: 0,
    page: 1,
    // limit: 5,
    snackMsg: "",
    alertTitle: "",
    open: true,
    snack: false,
    alert: false,
    confirm: false,
    end: false,
  });

  const [state, setState] = React.useState({
    event: {
      banner_inside_mobile: [],
      banner_inside_desktop: [],
      startdate_at: new Date(),
      enddate_at: null,
      eventTime: {},
    },
  });

  const [timer, setTimmer] = React.useState({
    startdate_at: null,
    enddate_at: null,
    balanceTime: 0,
    user_id: null,
  });

  const [nottimer, setNotTimmer] = React.useState({
    timestartdate_at: moment().format("HH.mm"),
    timeenddate_at: moment().format("HH.mm"),
  });

  const paginate = (array, page_number) => {
    const pageArr = [...array].filter((s) => s.partno === page_number);

    return pageArr;
    // return array.slice(
    //   page_number * page_size,
    //   page_number * page_size + page_size
    // );
  };

  const handleNext = () => {
    const page = quiz.page + 1;
    setQuiz({ ...quiz, page });
    window.scrollTo(0, 0);
    const _quiz = window.localStorage.getItem("_quiz");
    if (!!_quiz) {
      const beforeQuiz = JSON.parse(_quiz);

      window.localStorage.setItem(
        "_quiz",
        JSON.stringify({
          ...beforeQuiz,
          page,
        })
      );

      updateCache(
        {
          quiz: {
            ...beforeQuiz,
            page,
          },
        },
        +id
      );
    }
  };

  const handlePrev = () => {
    if (quiz.page > 1) {
      const page = quiz.page - 1;
      setQuiz({ ...quiz, page });
      window.scrollTo(0, 0);
      const _quiz = window.localStorage.getItem("_quiz");
      if (!!_quiz) {
        const beforeQuiz = JSON.parse(_quiz);

        window.localStorage.setItem(
          "_quiz",
          JSON.stringify({
            ...beforeQuiz,
            page,
          })
        );

        updateCache(
          {
            quiz: {
              ...beforeQuiz,
              page,
            },
          },
          +id
        );
      }
    }
  };

  const handleClose = () => {
    setQuiz({ ...quiz, open: false });
  };

  const classes = useStyles();

  const handleSave = () => {
    const error = {};
    let i = 1;
    quiz.quiz.forEach((s) => {
      s.question.forEach((q) => {
        if (q.value === "" || !!!q.value) {
          i++;
          error[0] = "ผู้สมัครยังตอบคำถามไม่ครบทุกข้อ ผู้สมัครไม่ได้ตอบคำถามข้อที่";
          error[i] = (
            <strong>
              Part {zeroPad(s.partno)} ข้อที่ {q.no}
            </strong>
          );
        }
      });
    });

    if (Object.keys(error).length > 0) {
      setQuiz({
        ...quiz,
        open: false,
        alert: true,
        alertTitle: "คุณยังตอบคำถามไม่ครบ",
        errorText: error,
      });
    } else {
      setQuiz({
        ...quiz,
        confirm: true,
      });
    }
  };

  const handleConfirm = () => {
    saveResult(quiz.quiz, id, state.event.questionform_id, navigate, quiz, setQuiz);
  };

  const handleQuiz = (value, secId, qId) => {
    const newvalue = quiz.quiz.map((v) => ({
      ...v,
      question: v.question.map((q) => ({
        ...q,
        value: v.secId === secId && q.qId === qId ? value : q.value,
      })),
    }));

    window.localStorage.setItem(
      "_quiz",
      JSON.stringify({
        section: newvalue,
        qgroupId: quiz.qgroupId,
        eventId: +id,
        page: quiz.page,
        user_id: timer.user_id,
      })
    );

    updateCache(
      {
        quiz: {
          section: newvalue,
          qgroupId: quiz.qgroupId,
          eventId: +id,
          page: quiz.page,
          user_id: timer.user_id,
        },
      },
      +id
    );

    setQuiz({
      ...quiz,
      quiz: newvalue,
    });
  };

  const alertConfirm = () => {
    setQuiz({ ...quiz, alert: false });
  };

  const handleSnackClose = () => {
    setQuiz({ ...quiz, snack: false });
  };

  const handleEndTime = () => {
    handleConfirm();
    // setQuiz({
    //   ...quiz,
    //   open: false,
    //   alert: true,
    //   alertTitle: "หมดเวลาทำแบบทดสอบ",
    //   errorText: {
    //     error: "หมดเวลาทำแบบทดสอบแล้ว",
    //   },
    // });
    // setTimeout(() => {
    //   handleConfirm();
    // }, 5000);
  };

  const confirmEnd = () => {
    navigate(`/quiz/${state.event.assetId}/complete`);
  };

  const maxPage = quiz.quiz.length;

  const urlParams = new URLSearchParams(window.location.search);
  const questionid = urlParams.get("id");

  const navigate = useNavigate();

  useEffect(() => {
    if (!!state.event.questionform_id) {
      loadQuiz(quiz, setQuiz, id, state.event.questionform_id, setTimmer, handleEndTime, state);
      inituser(state.event.assetId, state.event.slugurl, navigate);
    }

    if (state.event.assetId) {
      setNotTimmer({
        timestartdate_at: state.event.eventTime.timestartdate_at,
        timeenddate_at: state.event.eventTime.timeenddate_at,
      });

      if (state.event.eventTime.endDate) {
        handleEndTime();
      }
    }
  }, [state.event]);

  useEffect(() => {
    initPage(state, setState, id, navigate);
  }, [id]);

  return (
    <div className={classes.bg}>
      <Snackbar anchorOrigin={{ vertical: "top", horizontal: "center" }} open={quiz.snack} onClose={handleSnackClose} message={quiz.snackMsg} />
      <Backdrop className={classes.backdrop} open={quiz.open}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <DGAlert
        title={quiz.alertTitle || "แจ้งเตือน"}
        onConfirm={alertConfirm}
        description={Object.keys(quiz.errorText).map((e, k) => (
          <div key={k}>{quiz.errorText[e]}</div>
        ))}
        open={quiz.alert}
        labelConfirm="ตกลง"
      />

      <DGAlert
        title={quiz.alertTitle || "แจ้งเตือน"}
        onConfirm={confirmEnd}
        description={Object.keys(quiz.errorText).map((e, k) => (
          <div key={k}>{quiz.errorText[e]}</div>
        ))}
        open={quiz.end}
        labelConfirm="ตกลง"
      />

      <DGAlertQuiz
        title="ยืนยันการส่งคำตอบ"
        description="คุณสามารถเข้าทำแบบทดสอบได้เพียง 1 ครั้งเท่านั้นหากยืนยันคำตอบจะไม่สามารถกดส่งได้อีก คุณยืนยันที่จะส่งคำตอบหรือไม่"
        onConfirm={handleConfirm}
        close={() => setQuiz({ ...quiz, confirm: false })}
        open={quiz.confirm}
        labelConfirm="ตกลง"
        labelClose="ยกเลิก"
      />

      <div className={classes.banner}>
        <img
          src={isMobile ? `${process.env.REACT_APP_API_URL}/images/${!!state.event.banner_inside_mobile ? state.event.banner_inside_mobile[0] : ""}` : `${process.env.REACT_APP_API_URL}/images/${!!state.event.banner_inside_desktop ? state.event.banner_inside_desktop[0] : ""}`}
          alt=""
          width="100%"
        />
      </div>

      <LayoutQuiz>
        <Grid container spacing={3}>
          <Grid item xs={12} md={8}>
            <div className={classes.formInputBox}>
              <div className={classes.formInput}>
                <Typography variant="h5" color="secondary" className={clsx(classes.titleSpace, classes.headerText)}>
                  {quiz.name}
                </Typography>

                {paginate(quiz.quiz, quiz.page).map((s, k) => {
                  return (
                    <div key={k}>
                      <Alert className={classes.partName} icon={<ClassSharpIcon fontSize="inherit" color="primary" />}>
                        <strong>Part{zeroPad(s.partno)} : </strong>
                        {s.sectionname}
                      </Alert>

                      {s.question.map((v, k2) => {
                        return (
                          <div key={s.qId}>
                            <FormControl required error={false} style={{ marginTop: 16, width: "100%" }}>
                              <FormLabel className={classes.topic}>
                                {v.no}. {v.qName}
                              </FormLabel>
                              {v.pathFiles && v.pathFiles.length > 0 ? (
                                <div className={classes.imageQuiz}>
                                  <img src={`${process.env.REACT_APP_API_URL}/images/${v.pathFiles[0]}`} alt="" />
                                </div>
                              ) : (
                                ""
                              )}
                              {+v.questiontype === 2 && (
                                <RadioGroup name={`name_${v.qId}`} value={+v.value || null} onChange={(e) => handleQuiz(e.target.value, s.secId, v.qId)}>
                                  {v.ans.map((a) => (
                                    <FormControlLabel key={a.ansId} value={+a.ansId} control={<Radio color="primary" />} label={<div className={classes.labelradio}>{a.ansName}</div>} />
                                  ))}
                                </RadioGroup>
                              )}

                              {+v.questiontype === 1 && (
                                <TextField
                                  onChange={(e) => handleQuiz(e.target.value, s.secId, v.qId)}
                                  value={v.value}
                                  fullWidth
                                  error={false}
                                  variant="filled"
                                  placeholder="Answer"
                                  multiline
                                  minRows={4}
                                  InputLabelProps={{
                                    style: {
                                      padding: 8,
                                      fontWeight: 800,
                                      fontSize: 18,
                                      transform: "none",
                                      color: "#292726",
                                    },
                                    shrink: true,
                                  }}
                                  InputProps={{
                                    disableUnderline: true,
                                    style: {
                                      background: "#ffffff",
                                      fontSize: 18,
                                      border: "1px solid #dddddd",
                                    },
                                  }}
                                />
                              )}
                            </FormControl>
                          </div>
                        );
                      })}
                    </div>
                  );
                })}

                <div style={{ margin: "32px 0 32px 0", textAlign: "center" }}>
                  <Button variant="contained" className={classes.buttonPrev} onClick={handlePrev} disabled={quiz.page === 1}>
                    ย้อนกลับ
                  </Button>

                  {quiz.page === maxPage ? (
                    <Button variant="contained" color="primary" onClick={handleSave} className={classes.buttonNext}>
                      ส่งคำตอบ
                    </Button>
                  ) : (
                    <Button variant="contained" color="primary" className={classes.buttonNext} disabled={quiz.page === maxPage} onClick={handleNext}>
                      ถัดไป
                    </Button>
                  )}
                </div>
              </div>
            </div>
          </Grid>

          <Grid item xs={12} md={4}>
            <div
              style={{
                width: "100%",
                borderBottom: "none",
              }}
            >
              {isMobile ? (
                <div
                  style={{
                    border: "solid 1px #C8C8C8",
                    borderBottom: "none",
                    position: "fixed",
                    bottom: 0,
                    width: "100%",
                    background: "#ffffff",
                    display: !!timer.enddate_at ? "flex" : "none",
                  }}
                >
                  <CardContent style={{ padding: 8, width: "100%" }}>
                    <Typography variant="subtitle1" style={{ fontSize: 14 }} color="secondary">
                      เวลาสิ้นสุดทำแบบทดสอบ
                    </Typography>
                    <div className={classes.date}>
                      <div>
                        {moment(timer.enddate_at).format("DD/MM/YYYY")}
                        {!state.event?.timer_exam && ` ${nottimer.timeenddate_at} น.`}
                      </div>

                      {state.event?.timer_exam && <div>{moment(timer.enddate_at).format("HH.mm")} น.</div>}
                    </div>
                  </CardContent>
                  <div
                    style={{
                      textAlign: "center",
                      background: "#F5F5F5",
                      height: "75px",
                      maxWidth: "178px",
                      width: "100%",
                      padding: 8,
                      boxSizing: "border-box",
                      fontSize: 18,
                      color: "#292726",
                      display: state.event?.timer_exam ? "block" : "none",
                    }}
                  >
                    เหลือเวลาอีก
                    {!!timer.enddate_at && <Timer className={classes.countdownMobile} sec={timer.balanceTime} onComplete={() => handleEndTime()} />}
                  </div>
                </div>
              ) : (
                <div
                  style={{
                    border: "solid 1px #E5E5E5",
                    width: "100%",
                    display: !!timer.enddate_at ? "block" : "none",
                  }}
                >
                  <CardContent>
                    <Typography className={classes.startText} variant="subtitle1" color="secondary">
                      เวลาที่เริ่มทำแบบทดสอบ
                    </Typography>
                    <div className={classes.date}>
                      <div>{moment(timer.startdate_at).format("DD/MM/YYYY")}</div>
                      {state.event?.timer_exam ? <div>{moment(timer.startdate_at).format("HH.mm")} น.</div> : <div> {nottimer.timestartdate_at}</div>}
                    </div>
                    <Typography className={classes.startText} variant="subtitle1" color="secondary">
                      เวลาสิ้นสุดทำแบบทดสอบ
                    </Typography>
                    <div className={classes.date}>
                      <div>{moment(timer.enddate_at).format("DD/MM/YYYY")}</div>
                      {state.event?.timer_exam ? <div>{moment(timer.enddate_at).format("HH.mm")} น.</div> : <div>{nottimer.timeenddate_at}</div>}
                    </div>
                  </CardContent>
                  <div
                    style={{
                      textAlign: "center",
                      background: "#F5F5F5",
                      height: "139px",
                      padding: 8,
                      boxSizing: "border-box",
                      display: state.event?.timer_exam ? "block" : "none",
                    }}
                  >
                    <p>เหลือเวลาอีก</p>

                    {!!timer.enddate_at && <Timer className={clsx(classes.titleSpace, classes.countdown)} sec={timer.balanceTime} onComplete={() => handleEndTime()} />}
                  </div>
                </div>
              )}
            </div>
          </Grid>
        </Grid>
      </LayoutQuiz>
    </div>
  );
};

export default Quiz;
